import { userService } from "../services";
// import userData from "../data/users.js";
import { dictionary } from "../helpers";

function findSetting(state, key) {
  if (
    state &&
    state.activeUser &&
    state.activeUser.settings &&
    state.activeUser.settings.find(setting => setting.type === key)
  ) {
    return state.activeUser.settings.find(setting => setting.type === key)
      .value;
  }
  return null;
}

export const user = {
  namespaced: true,
  state: { activeUser: null },
  mutations: {
    updateActiveUser(state, activeUser) {
      state.activeUser = activeUser;
    }
  },
  actions: {
    async getUser({ commit }, { userId }) {
      await userService.getUser(userId).then(
        user => {
          commit("updateActiveUser", user);
        },
        error => {
          console.log(error);
          commit("updateActiveUser", null);
          this.commit("authentication/loginFailure", error);
        }
      );
    },
    updatePassword(context, { user, password }) {
      if (user) {
        return new Promise((resolve, reject) => {
          userService.updatePassword(user, password).then(
            response => {
              resolve(response);
            },
            error => {
              reject(error);
            }
          );
        });
      }
    },
    updateUser(context, { user, password }) {
      if (user) {
        return new Promise((resolve, reject) => {
          userService.updateUser(user, password).then(
            response => {
              resolve(response);
            },
            error => {
              reject(error);
            }
          );
        });
      }
    },
    deleteUser(context, { user }) {
      if (user) {
        return new Promise((resolve, reject) => {
          userService.deleteUser(user).then(
            response => {
              resolve(response);
            },
            error => {
              reject(error);
            }
          );
        });
      }
    },
    async loadUsers() {
      return new Promise((resolve, reject) => {
        userService.loadUsers().then(
          response => {
            if (response != null) {
              let users = [];
              response.forEach(user => {
                if (
                  user &&
                  user.id &&
                  this.state.user.activeUser &&
                  user.id != this.state.user.activeUser.id
                ) {
                  users.push(user);
                }
              });
              resolve(users);
            }
          },
          error => {
            reject(error);
          }
        );
      });
    }
  },
  getters: {
    allowAddGoods(state) {
      const value = findSetting(state, dictionary.settings.allow.add_goods);
      return value && value === "1";
    },
    allowEditUsers(state) {
      const value = findSetting(state, dictionary.settings.allow.edit_users);
      return value && value === "1";
    },
    allowEmptyContactPerson(state) {
      const value = findSetting(
        state,
        dictionary.settings.allow.empty_contact_person
      );
      return !value || value === "1";
    },
    allowEmptyContactPhone(state) {
      const value = findSetting(
        state,
        dictionary.settings.allow.empty_contact_phone
      );
      return !value || value === "1";
    },
    allowEmptyGoodsReference(state) {
      const value = findSetting(
        state,
        dictionary.settings.allow.empty_goods_reference
      );
      return !value || value === "1";
    },
    allowEmptyReference1(state) {
      const value = findSetting(
        state,
        dictionary.settings.allow.empty_booking_reference_1
      );
      return value && value === "1";
    },
    bookingType(state) {
      const value = findSetting(state, dictionary.settings.booking_type);
      return value;
    },
    hideAddressInfo(state) {
      const value = findSetting(state, dictionary.settings.hide.address_info);
      return value && value === "1";
    },
    defaultGoodsCll(state) {
      const value = findSetting(state, dictionary.settings.default.goods.cll);
      return value ? value : "0,00";
    },
    defaultGoodsUnitType(state) {
      const defaultUnitType = findSetting(
        state,
        dictionary.settings.default.goods.unit_type
      );

      let value = null;

      if (defaultUnitType) {
        state.activeUser.unit_types.forEach(unitType => {
          if (
            unitType &&
            unitType.external_key &&
            unitType.external_key == defaultUnitType
          ) {
            value = unitType;
          }
        });
      }
      return value;
    },
    defaultGoodsDescription(state) {
      const value = findSetting(
        state,
        dictionary.settings.default.goods.description
      );
      return value ? value : "";
    },
    defaultGoodsWeight(state) {
      const value = findSetting(
        state,
        dictionary.settings.default.goods.weight
      );
      return value ? value : "0,00";
    },
    defaultName(state) {
      const value = findSetting(state, dictionary.settings.default.name);
      return value ? value : "";
    },
    defaultVehilceType(state) {
      const value = findSetting(
        state,
        dictionary.settings.default.vehicle_type
      );
      return value ? value : "";
    },
    hideBookingInsurance(state) {
      const value = findSetting(
        state,
        dictionary.settings.hide.booking.insurance
      );
      return value && value === "1";
    },
    hideBookingNotifications(state) {
      const value = findSetting(
        state,
        dictionary.settings.hide.booking.notifications
      );
      return value && value === "1";
    },
    hideBookingReferences(state) {
      const value = findSetting(
        state,
        dictionary.settings.hide.booking.references
      );
      return value && value === "1";
    },
    hideBookingRemarks(state) {
      const value = findSetting(
        state,
        dictionary.settings.hide.booking.remarks
      );
      return value && value === "1";
    },
    hideGoodsUnitType(state) {
      const value = findSetting(
        state,
        dictionary.settings.hide.goods.unit_type
      );
      return value && value === "1";
    },
    hideContact(state) {
      const value = findSetting(state, dictionary.settings.hide.contact);
      return value && value === "1";
    },
    hideGoodsADR(state) {
      const value = findSetting(state, dictionary.settings.hide.goods.adr);
      return value && value === "1";
    },
    hideGoodsDimensions(state) {
      const value = findSetting(
        state,
        dictionary.settings.hide.goods.dimensions
      );
      return value && value === "1";
    },
    hideGoodsPipes(state) {
      const value = findSetting(state, dictionary.settings.hide.goods.pipes);
      return value && value === "1";
    },
    hideGoodsReference(state) {
      const value = findSetting(
        state,
        dictionary.settings.hide.goods.reference
      );
      return value && value === "1";
    },
    hideGoodsSLV(state) {
      const value = findSetting(state, dictionary.settings.hide.goods.slv);
      return value && value === "1";
    },
    hidePrice(state) {
      const value = findSetting(state, dictionary.settings.hide.price);
      return value && value === "1";
    },
    notificationToBooker(state) {
      const value = findSetting(
        state,
        dictionary.settings.default.notification_to_booker
      );
      return value ? value === "1" : true;
    },
    ownAddressEditable(state) {
      const value = findSetting(
        state,
        dictionary.settings.own_address_editable
      );
      return value && value === "1";
    },
    priceInclVat(state) {
      const value = findSetting(state, dictionary.settings.price_incl_vat);
      return value && value === "1";
    },
    unitTypes(state) {
      return state.activeUser.unit_types ? state.activeUser.unit_types : [];
    },
    useOwnAddressAs(state) {
      const value = findSetting(state, dictionary.settings.use_own_address_as);
      return value;
    },
    vehicleTypes(state) {
      return state.activeUser.vehicle_types
        ? state.activeUser.vehicle_types
        : [];
    },
    photoDocumentation(state) {
      const value = findSetting(
        state,
        dictionary.settings.default.photo_documentation
      );
      return value ? value === "1" : false;
    },
    allowNoSignature(state) {
      const value = findSetting(
        state,
        dictionary.settings.default.allow_no_signature
      );
      return value ? value === "1" : false;
    }
  }
};
